import { connect } from 'react-redux'
import { getFormValues } from 'redux-form'
import Component from './Component'
import { fetchRevisions } from '../../Handlers/fetchRevisions'
import { FORM_NAME } from '../../Form'

const mapStateToProps = (state) => {
  const formValues = getFormValues(FORM_NAME)(state) || {}
  return {
    ramsRecordId: formValues.id,
    revisions: state.modals.RamsRecord.revisions.data,
    loading: state.modals.RamsRecord.revisions.loading,
  }
}

const mapDispatchToProps = (dispatch) => ({
  onFetchRevisions: (ramsRecordId) => dispatch(fetchRevisions(ramsRecordId)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Component)
